import React from 'react';
import './MobileCard.css';

/**
 * 移动端友好的卡片组件
 * 用于在小屏幕设备上展示信息
 * 
 * @param {Object} props - 组件属性
 * @param {React.ReactNode} props.children - 卡片内容
 * @param {string} props.className - 额外的CSS类名
 * @param {Function} props.onClick - 点击卡片时的回调函数
 * @param {string} props.title - 卡片标题
 * @param {React.ReactNode} props.extra - 卡片右上角额外内容
 * @returns {JSX.Element} 移动端卡片组件
 */
const MobileCard = ({ children, className = '', onClick, title, extra }) => {
  return (
    <div 
      className={`mobile-card ${className}`} 
      onClick={onClick}
    >
      {(title || extra) && (
        <div className="mobile-card-header">
          {title && <h3 className="mobile-card-title">{title}</h3>}
          {extra && <div className="mobile-card-extra">{extra}</div>}
        </div>
      )}
      <div className="mobile-card-content">
        {children}
      </div>
    </div>
  );
};

export default MobileCard; 